import * as React from 'react';

import { Title } from 'common/components';
import { Glossary, ContractGL } from 'common/utils/glossary';

const MESSAGE_TYPES = {
  notFoundAnyPlan: ContractGL.NotFoundAnyContract,
  otherError: ContractGL.OtherError
} as const;
export type MESSAGE_TYPES_KEY = keyof typeof MESSAGE_TYPES;

interface Props {
  /** メッセージを表示するか否か */
  show: boolean;
  /** メッセージの種類 */
  messageType?: MESSAGE_TYPES_KEY;
  /** グロッサリ */
  glossary: Glossary;
}

/**
 * 契約中プランのリストに表示するエラーメッセージのPresentation Component
 */
export const ContractPlanListMessage: React.FC<Props> = ({
  show,
  messageType,
  glossary
}) => {
  const messageText = messageType && glossary.glx(MESSAGE_TYPES[messageType]);
  // 表示するComponentをメモライズ
  const _message = React.useMemo(() => {
    return show && messageType ? (
      <Title
        type="listMessage"
        data-test={`${messageType}-message`}
        className="purchase-listMessage"
      >
        {messageText}
      </Title>
    ) : null;
  }, [show, messageType, messageText]);

  return _message;
};
